/**
 * Build element ID for a level block
 */
export const getLevelElementId = (level: string): string => `level-block-${level}`;
